import React from "react";
import PropTypes from "prop-types";
import OverviewSection from "./OverviewSection";
import { DeliveryInstructionsForm } from "~/assets/js/components/Forms/modules";

const DeliveryInstructions = ({ handleOnChange, defaultValues }) => {
    return (
        <OverviewSection title="overview.deliveryInstructions.title">
            <DeliveryInstructionsForm
                handleChange={handleOnChange}
                formValues={defaultValues}
            />
        </OverviewSection>
    );
};

DeliveryInstructions.propTypes = {
    handleOnChange: PropTypes.func.isRequired,
    defaultValues: PropTypes.any,
};

export default DeliveryInstructions;
